export const RightMapPanel = () => {
  return (
    <div >
      Right Map Panel
    </div>
  );
};